import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from '../OrderSummary.module.scss';
import buttonStyles from 'components/Button/Button.module.scss';
import { ContentType, ExternalLink, LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { CONNECT_TO_SALES_PATH } from 'components/App/Routes/Routes';
import { FlatEntry } from 'services/cms/flattenContentful';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { SproutButton } from 'components/Button/SproutButton';
import { ORDER_SUMMARY_BUTTON_TEST_ID } from './OrderSummaryButton.const';
import { ExternalLinkV2 } from 'components/ContentLinkV2/ExternalLinkV2';

interface ISelfServiceProps {
  isContinueButtonDisabled?: boolean;
  continueButtonClickHandler?: React.MouseEventHandler<HTMLButtonElement>;
  userMustContactSales?: boolean;
}

export const OrderSummaryButton: React.FC<ISelfServiceProps> = ({
  isContinueButtonDisabled,
  continueButtonClickHandler,
  userMustContactSales,
}) => {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;
  const { t } = useTranslation();

  return (
    <div className={cx(styles.action, { [styles.actionFixed]: isMobile })}>
      {userMustContactSales ? (
        <ExternalLinkV2
          className={cx(buttonStyles.button, buttonStyles.buttonVariantPrimary)}
          entry={
            {
              contentType: ContentType.EXTERNAL_LINK,
              newTab: true,
              title: t('contact-sales'),
              url: CONNECT_TO_SALES_PATH,
            } as FlatEntry<ExternalLink>
          }
        />
      ) : (
        <SproutButton
          variant={LinkVariant.PRIMARY}
          fullwidth
          data-testid={ORDER_SUMMARY_BUTTON_TEST_ID.continue}
          disabled={isContinueButtonDisabled}
          onClick={continueButtonClickHandler}
        >
          {t('continue')}
        </SproutButton>
      )}
    </div>
  );
};
